// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".collapse-meta {\n  margin: 2rem -15px -40px -15px !important;\n  width: -webkit-fill-available;\n}\n.text-break-meta {\n  word-break: break-all !important;\n  z-index: 0 !important;\n}\n.max-width-col {\n  min-width: 180px !important;\n}\n", ""]);
// Exports
module.exports = exports;
